import axios from "axios";
import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import Barcode from "react-barcode";
import {baseUrl, userLocation} from "../Univ.js";
function LabReportIpAll() {
    const {appt_id} = useParams();
    const [viewlabdata, setViewLabData] = useState([]);
    const [labtestData, setLabTestData] = useState([]);
    const [fetchedResults, setFetchedResults] = useState([]);
    const [fetchedAbnormal, setFetchedAbnormal] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [hospData, setHospData] = useState([]);
    // ============================================================
    // FETCH INITIAL DATA
    // ============================================================
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${baseUrl}ip-lab-report-all/${appt_id}/`);
                const testData = response.data || [];
                setLabTestData(testData);
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoading(false);
            }
        };
        if (appt_id) {
            fetchData();
        }
        // ========================================================
        // HOSPITAL DATA
        // ========================================================
        try {
            axios
                .get(`${baseUrl}view-hospital/${userLocation}/`)
                .then((response) => {
                    setHospData(response.data || []);
                });
        } catch (error) {
            console.log(error);
        }
    }, [appt_id]);
    // ============================================================
    // FETCH ALL LAB TEST DETAILS
    // ============================================================
    useEffect(() => {
        if (labtestData.length > 0) {
            fetchLabData();
        }
    }, [labtestData]);
    const fetchLabData = async () => {
        const fetchedData = [];
        const allFetchedResults = [];
        const allFetchedAbnormal = [];
        for (const test of labtestData) {
            const ltestIds = test?.ltest_id ? String(test.ltest_id)
                .split(",")
                .map((item) => item.trim())
                .filter(Boolean) : [];
            const results = test?.results ? String(test.results)
                .split(",")
                .map((item) => item.trim()) : [];
            const abnormal = test?.abnormal_status ? String(test.abnormal_status)
                .split(",")
                .map((item) => item.trim()) : [];
            let resultIndex = 0;
            // Collect each lab test definition.
            for (const ltestId of ltestIds) {
                try {
                    const response = await axios.get(`${baseUrl}lab-test-view/${ltestId}/`);
                    const testDetails = response.data || [];
                    testDetails.forEach((labTest) => {
                        fetchedData.push({
                            ...labTest,
                            _category: labTest?.cat?.category || "",
                            _subCategory: labTest?.subcat?.subcat || "",
                            _resultIndex: resultIndex,
                        });
                        resultIndex++;
                    });
                } catch (error) {
                    console.error(`Error fetching lab test ${ltestId}:`, error);
                }
            }
            // Keep results and abnormal statuses in separate arrays.
            allFetchedResults.push(...results);
            allFetchedAbnormal.push(...abnormal);
        }
        setViewLabData(fetchedData);
        setFetchedResults(allFetchedResults);
        setFetchedAbnormal(allFetchedAbnormal);
    };
    // ============================================================
    // PRINT
    // ============================================================
    const handlePrint = () => {
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
    };
    // ============================================================
    // LOADING
    // ============================================================
    if (isLoading) {
        return (<section className="lab-report-page">

            <div className="lab-report-print">

                Loading...

            </div>

        </section>);
    }
    // ============================================================
    // NO DATA
    // ============================================================
    if (!labtestData || labtestData.length === 0) {
        return (<section className="lab-report-page">

            <div className="lab-report-print">

                No data available.

            </div>

        </section>);
    }
    // ============================================================
    // FIRST LAB DATA
    // ============================================================
    const firstLab = labtestData.length > 0 ? labtestData[0] : null;
    // ============================================================
    // RENDER
    // ============================================================
    return (<section className="lab-report-page">


        {/* =====================================================
                PRINT AREA
            ===================================================== */}

        <div
            id="invoice-print"
            className="lab-report-print"
        >


            {/* =================================================
                    HOSPITAL HEADER
                ================================================= */}
            <div
                style={{
                    width: "100%", margin: 0, padding: 0, overflow: "hidden", lineHeight: 0
                }}
            >
                {hospData.map((hospital) => (<img
                    key={hospital.id}
                    src={hospital.logo}
                    alt="Hospital Header"
                    style={{
                        width: "100%",
                        height: "110px",
                        display: "block",
                        margin: 0,
                        padding: 0,
                        border: "none",
                        objectFit: "fill"
                    }}
                />))}
            </div>

            {/* =================================================
                    PATIENT HEADER
                ================================================= */}

            {firstLab && (<div className="lab-patient-box">


                {/* =========================================
                            LEFT COLUMN
                        ========================================= */}

                <div className="lab-patient-column">


                    {/* PID / BARCODE */}

                    <div className="lab-info-row lab-pid-row">

                        <div className="lab-label">

                            PID :

                        </div>


                        <div className="lab-value lab-barcode">

                            {firstLab?.pat?.pat_id && (<Barcode
                                width={1.8}
                                height={48}
                                fontSize={11}
                                margin={0}
                                value={String(firstLab.pat.pat_id)}
                            />)}

                        </div>

                    </div>


                    {/* NAME */}

                    <div className="lab-info-row">

                        <div className="lab-label">

                            Name :

                        </div>


                        <div className="lab-value">

                            {firstLab?.pat?.patient || "-"}

                        </div>

                    </div>


                    {/* AGE / GENDER */}

                    <div className="lab-info-row">

                        <div className="lab-label">

                            Age / Gender :

                        </div>


                        <div className="lab-value">

                            {firstLab?.pat?.age || "-"}

                            {" / "}

                            {firstLab?.pat?.gender || "-"}

                        </div>

                    </div>

                </div>


                {/* =========================================
                            RIGHT COLUMN
                        ========================================= */}

                <div className="lab-patient-column">


                    {/* SAMPLE DATE */}

                    <div className="lab-info-row">

                        <div className="lab-label">

                            Sample Date :

                        </div>


                        <div className="lab-value">

                            {firstLab?.sample_date || "-"}

                        </div>

                    </div>


                    {/* REPORT DATE */}

                    <div className="lab-info-row">

                        <div className="lab-label">

                            Report Date :

                        </div>


                        <div className="lab-value">

                            {firstLab?.sample_date || "-"}

                        </div>

                    </div>


                    {/* MOBILE */}

                    <div className="lab-info-row">

                        <div className="lab-label">

                            Mobile :

                        </div>


                        <div className="lab-value">

                            {firstLab?.pat?.mobile || "-"}

                        </div>

                    </div>


                    {/* CONSULTANT */}

                    <div className="lab-info-row">

                        <div className="lab-label">

                            Consultant :

                        </div>


                        <div className="lab-value">

                            {firstLab?.cons?.consultant ? `Dr. ${firstLab.cons.consultant}` : "-"}

                        </div>

                    </div>

                </div>

            </div>)}


            {/* =================================================
                    LAB RESULT TABLE
                ================================================= */}

            <div
                className="lab-result-wrapper"
                style={{marginTop: "20px"}}
            >

                <table className="lab-result-table">


                    <colgroup>

                        <col className="col-test"/>

                        <col className="col-value"/>

                        <col className="col-unit"/>

                        <col className="col-range"/>

                    </colgroup>


                    <thead>

                    <tr>

                        <th>
                            Test Description
                        </th>

                        <th>
                            Values
                        </th>

                        <th>
                            Unit
                        </th>

                        <th>
                            Ref. Range
                        </th>

                    </tr>

                    </thead>


                    <tbody>


                    {viewlabdata.length > 0 ? (viewlabdata.map((testsArray, testIndex) => {
                        const resultIndex = testIndex;
                        const resultValue =
                            fetchedResults?.[resultIndex] !== undefined
                                ? fetchedResults[resultIndex]
                                : "-";
                        const abnormalStatus = String(fetchedAbnormal[resultIndex] ?? "0").trim();
                        const isAbnormal = abnormalStatus === "1";
                        const currentCategory = testsArray?._category || "";
                        const currentSubCategory = testsArray?._subCategory || "";
                        const previousTest = testIndex > 0 ? viewlabdata[testIndex - 1] : null;
                        const previousCategory = previousTest?._category || "";
                        const previousSubCategory = previousTest?._subCategory || "";
                        const showCategory = currentCategory && currentCategory !== previousCategory;
                        const showSubCategory = currentSubCategory && (showCategory || currentSubCategory !== previousSubCategory);
                        return (<React.Fragment
                            key={`lab-result-${testIndex}`}
                        >


                            {/* =================================
                                                    CATEGORY
                                                ================================= */}

                            {showCategory && (<tr className="lab-category-row">

                                <td colSpan="4">

                                    {currentCategory}

                                </td>

                            </tr>)}


                            {/* =================================
                                                    SUB CATEGORY
                                                ================================= */}

                            {showSubCategory && (<tr className="lab-subcategory-row">

                                <td colSpan="4">

                                    {currentSubCategory}

                                </td>

                            </tr>)}


                            {/* =================================
                                                    TEST RESULT
                                                ================================= */}

                            <tr>


                                {/* TEST DESCRIPTION */}

                                <td className="test-description">

                                    <div className="test-name">

                                        {testsArray?.test || "-"}

                                    </div>


                                    {testsArray?.method && (<div className="test-method">

                                        {testsArray.method}

                                    </div>)}

                                </td>


                                {/* VALUE */}

                                <td
                                    className="test-value"
                                    style={{
                                        textDecoration: isAbnormal ? "underline" : "none",
                                        textDecorationColor: "red",
                                        textDecorationThickness: "3px",
                                        textUnderlineOffset: "3px",
                                        fontWeight: 700,
                                    }}
                                >
                                    {resultValue}
                                </td>

                                {/* UNIT */}

                                <td className="test-unit">

                                    {testsArray?.units || "-"}

                                </td>


                                {/* REFERENCE RANGE */}

                                <td className="test-range">

                                    {testsArray?.ranges || "-"}

                                </td>

                            </tr>

                        </React.Fragment>);
                    })) : (<tr>

                        <td
                            colSpan="4"
                            className="no-results"
                        >

                            No laboratory results available.

                        </td>

                    </tr>)}

                    </tbody>

                </table>

            </div>


            {/* =================================================
                    REPORT FOOTER
                ================================================= */}

            <div className="lab-report-footer">


                {/* END OF REPORT */}

                <div className="report-end">

                    *** End of Report ***

                </div>


                {/* LAB TECHNICIAN */}

                <div className="technician-signature">

                    Lab Technician

                </div>


                {/* DISCLAIMER */}

                <div className="lab-disclaimer">

                    <strong>
                        Disclaimer:
                    </strong>{" "}

                    All investigations have their limitations which
                    are imposed by the limits of sensitivity and
                    specificity of individual assay procedures as
                    well as the specimen received by the laboratory.
                    Isolated laboratory investigations never confirm
                    the final diagnosis of the disease. They only help
                    in arriving at a diagnosis in conjunction with
                    clinical presentation and other related
                    investigations. Report may vary depending on
                    technology. Values of two technologies are not
                    comparable.

                </div>

            </div>

        </div>


        {/* =====================================================
                PRINT BUTTON
            ===================================================== */}

        <div className="lab-print-button-container">

            <button
                type="button"
                className="lab-print-button"
                onClick={handlePrint}
            >

                Print

            </button>

        </div>

    </section>);
}
export default LabReportIpAll;